/**
 * Fuzzy search using Fuse.js
 *
 * This exports a function to create a fuse instance with sensible defaults.
 */

import Fuse from 'fuse.js';

export default function initializeFuseJsInstance(things, keys) {
  const options = {
    shouldSort: true,
    includeScore: false,
    threshold: 0.3,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 3,
    keys: keys,
  };
  const fuse = new Fuse(things, options);
  return fuse;
}



// WEBPACK FOOTER //
// ./src/fuzzySearch.js